// Calendar download utility using lazy-loaded ics.js
export async function downloadEventCalendar(eventData) {
    try {
        // Lazy load ics library
        const ics = await import(/* webpackChunkName: "ics" */ 'ics');

        const { error, value } = ics.createEvents([{
            title: eventData.title,
            description: eventData.description || '',
            location: eventData.location || '',
            start: eventData.start,
            end: eventData.end,
            url: eventData.url || window.location.href
        }]);

        if (error) {
            console.error('Error creating calendar event:', error);
            alert('Fehler beim Erstellen der Kalenderdatei. Bitte versuchen Sie es später erneut.');
            return;
        }

        if (!value) {
            console.error('No ICS content generated');
            alert('Fehler beim Erstellen der Kalenderdatei. Bitte versuchen Sie es später erneut.');
            return;
        }

        // Generate filename
        const filename = `${eventData.title.replace(/[^a-zA-Z0-9]/g, '_').substring(0, 50)}_${eventData.start[0]}${String(eventData.start[1]).padStart(2, '0')}${String(eventData.start[2]).padStart(2, '0')}.ics`;

        // Create and trigger download manually
        const blob = new Blob([value], { type: 'text/calendar;charset=utf-8' });
        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = filename;
        link.style.display = 'none';

        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        // Clean up the URL object
        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error('Error downloading calendar:', err);
        alert('Fehler beim Herunterladen der Kalenderdatei. Bitte versuchen Sie es später erneut.');
    }
}

// Helper function to extract event data from DOM
export function extractEventDataFromDOM(element) {
    const eventContainer = element.closest('[data-event-id]');
    if (!eventContainer) {
        console.error('No event container found');
        return null;
    }

    const eventId = eventContainer.getAttribute('data-event-id');
    const eventTitle = eventContainer.getAttribute('data-event-title');
    const eventDescription = eventContainer.getAttribute('data-event-description') || '';
    const eventLocation = eventContainer.getAttribute('data-event-location') || '';
    const eventUrl = eventContainer.getAttribute('data-event-url') || window.location.href;

    // Get date from the element's data attributes
    const startDate = element.getAttribute('data-event-start');
    const endDate = element.getAttribute('data-event-end');

    if (!startDate || !endDate) {
        console.error('Missing event date data');
        return null;
    }

    // Parse dates - assuming format: "YYYY-MM-DD HH:MM:SS"
    const parseDateTime = (dateTimeStr) => {
        const [date, time] = dateTimeStr.split(' ');
        const [year, month, day] = date.split('-').map(Number);
        const [hour, minute] = time ? time.split(':').map(Number) : [0, 0];

        return [year, month, day, hour, minute];
    };

    return {
        id: eventId,
        title: eventTitle,
        description: eventDescription,
        location: eventLocation,
        url: eventUrl,
        start: parseDateTime(startDate),
        end: parseDateTime(endDate)
    };
}
